import { Competition, Project, Team } from "@brg/api"
import { PROMT_COURSES } from "core/controllers/PromtCourseController"
import { ModuleItem } from "shared/pages/myCourses/CoursePage/components/ModuleItem"

export const promptProjectRequiredTags = [
    '1344d3b0296e4bdaa589ab4b2194ae3a',//вид
    '5d7845bdd4304a1d9140077373976ed4', //ау
    '87538e152f5c47179b7a9130d63bf33c', //наратив
    '0ecb6880f5594e9282c39fa1f33a20a9',//вайбкод,
    'f234884b45e140e49d7f3839ec33c4f0', //инстр
    '92ca3f83c7da46d396fe1010e4e58df1',//ИИ-бренд 
    'ef5950762d304a13a51f01136584ac2f'//нейрофото
]

export enum PromtRedirectStatus {
    default = 'default',
    member = 'member',
    notMember = 'notMember'
}

export const promptReplacedName = {
    '4037b3d8f0564d1ea2950bac9dbc2381': 'prompt-video',
    'c392fe0bbd3e470eb0f08853e741b49c': 'prompt-brand',
    'a61b1315ce644005b13d5f97d1da3ac7': 'prompt-code'
}

export const promptFormsId = {
    '4037b3d8f0564d1ea2950bac9dbc2381': 'c06aec5ab02044b882ba91d103b37759',
    'c392fe0bbd3e470eb0f08853e741b49c': 'f4e0a260097e4d95a3661219c6c3a661',
    'a61b1315ce644005b13d5f97d1da3ac7': '3ab31a98b6b140318fad91e8dcb212b4'
}

export const promptTeamIdByFormId = Object.entries(promptFormsId)?.reduce((acc,[k,v]) => {
    if (k) {
        return {...acc, [v]: k}
    } else {
        return acc
    }
} , {})

export const isPromptModule = (projectId?: string) => {
   if (!projectId) return false;
   return Object.values(PROMT_COURSES)?.some((prompt) => prompt?.moduleProjectId === projectId)
}

export const PROMT_MODULE_ROUTES: Record<string, string> = {
    '6f879803bcc842c8b9ae08007e6b607f': '/prompt-video/contest',
    '5b488948d1674daab6b8cc4288a42ef9': '/prompt-brand/contest',
    'e90d23c67aad4027b11a536948206a19': '/prompt-code/contest',
};

export const getPromptModuleSlug = (projectId: string): string | null => {
    return PROMT_MODULE_ROUTES[projectId] || null;
}

export const getPromptModuleRoute = (id: string) => {
    const teamId = promptTeamIdByFormId[id as keyof {}]
    const replacedName = promptReplacedName[teamId]
    const promptData = PROMT_COURSES[replacedName]
    const moduleId = promptData?.moduleProjectId
    return PROMT_MODULE_ROUTES[moduleId] || `/project/${moduleId}`
}

export const getPromptModuleRouteFullUrl = (id: string): string | null => {
    const teamId = promptTeamIdByFormId[id as keyof {}]
    const replacedName = promptReplacedName[teamId]
    const promptData = PROMT_COURSES[replacedName]
    const moduleId = promptData?.moduleProjectId
    const promptRoute = PROMT_MODULE_ROUTES[moduleId];
    if (!promptRoute) return null;
    return `${process.env.REACT_APP_URL_MEDIIIA_COM}/ai${promptRoute}`;
}

export const getPromtOrDefaultCompetitionRoute = (competition: any) => {
    const moduleId = competition?.lmsModuleProjectId;
    const promptRoute = PROMT_MODULE_ROUTES[moduleId];
    return promptRoute ? 
    `${process.env.REACT_APP_URL_MEDIIIA_COM}/ai${promptRoute}`  : 
    `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${competition.competitionId}` 
}

export const getPromptRequiredTags = (projectId: string) => {
    const moduleInfo = Object.values(PROMT_COURSES)?.find((prompt) => prompt?.moduleProjectId === projectId)

    if (moduleInfo) {
        return moduleInfo?.additionalRequiredTags
    }
    return []
}
export const getPromptModuleFullUrl = (moduleProjectId: string): string | null => {
    const promptRoute = PROMT_MODULE_ROUTES[moduleProjectId];
    if (!promptRoute) return null;
    return `${process.env.REACT_APP_URL_MEDIIIA_COM}/ai${promptRoute}`;
}
import { Competition, Project, Team } from "@brg/api"
import { PROMT_COURSES } from "core/controllers/PromtCourseController"
import { ModuleItem } from "shared/pages/myCourses/CoursePage/components/ModuleItem"

export const promptProjectRequiredTags = [
    '1344d3b0296e4bdaa589ab4b2194ae3a',//вид
    '5d7845bdd4304a1d9140077373976ed4', //ау
    '87538e152f5c47179b7a9130d63bf33c', //наратив
    '0ecb6880f5594e9282c39fa1f33a20a9',//вайбкод,
    'f234884b45e140e49d7f3839ec33c4f0', //инстр
    '92ca3f83c7da46d396fe1010e4e58df1',//ИИ-бренд 
    'ef5950762d304a13a51f01136584ac2f'//нейрофото
]

export enum PromtRedirectStatus {
    default = 'default',
    member = 'member',
    notMember = 'notMember'
}

export const promptReplacedName = {
    '4037b3d8f0564d1ea2950bac9dbc2381': 'prompt-video',
    'c392fe0bbd3e470eb0f08853e741b49c': 'prompt-brand',
    'a61b1315ce644005b13d5f97d1da3ac7': 'prompt-code'
}

export const promptFormsId = {
    '4037b3d8f0564d1ea2950bac9dbc2381': 'c06aec5ab02044b882ba91d103b37759',
    'c392fe0bbd3e470eb0f08853e741b49c': 'f4e0a260097e4d95a3661219c6c3a661',
    'a61b1315ce644005b13d5f97d1da3ac7': '3ab31a98b6b140318fad91e8dcb212b4'
}

export const promptTeamIdByFormId = Object.entries(promptFormsId)?.reduce((acc,[k,v]) => {
    if (k) {
        return {...acc, [v]: k}
    } else {
        return acc
    }
} , {})

export const isPromptModule = (projectId?: string) => {
   if (!projectId) return false;
   return Object.values(PROMT_COURSES)?.some((prompt) => prompt?.moduleProjectId === projectId)
}

export const PROMT_MODULE_ROUTES: Record<string, string> = {
    '6f879803bcc842c8b9ae08007e6b607f': '/prompt-video/contest',
    '5b488948d1674daab6b8cc4288a42ef9': '/prompt-brand/contest',
    'e90d23c67aad4027b11a536948206a19': '/prompt-code/contest',
};

export const getPromptModuleSlug = (projectId: string): string | null => {
    return PROMT_MODULE_ROUTES[projectId] || null;
}

export const getPromptModuleRoute = (id: string) => {
    const teamId = promptTeamIdByFormId[id as keyof {}]
    const replacedName = promptReplacedName[teamId]
    const promptData = PROMT_COURSES[replacedName]
    const moduleId = promptData?.moduleProjectId
    return PROMT_MODULE_ROUTES[moduleId] || `/project/${moduleId}`
}

export const getPromptModuleRouteFullUrl = (id: string): string | null => {
    const teamId = promptTeamIdByFormId[id as keyof {}]
    const replacedName = promptReplacedName[teamId]
    const promptData = PROMT_COURSES[replacedName]
    const moduleId = promptData?.moduleProjectId
    const promptRoute = PROMT_MODULE_ROUTES[moduleId];
    if (!promptRoute) return null;
    return `${process.env.REACT_APP_URL_MEDIIIA_COM}/ai${promptRoute}`;
}

export const getPromtOrDefaultCompetitionRoute = (competition: any) => {
    const moduleId = competition?.lmsModuleProjectId;
    const promptRoute = PROMT_MODULE_ROUTES[moduleId];
    return promptRoute ? 
    `${process.env.REACT_APP_URL_MEDIIIA_COM}/ai${promptRoute}`  : 
    `${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${competition.competitionId}` 
}

export const getPromptRequiredTags = (projectId: string) => {
    const moduleInfo = Object.values(PROMT_COURSES)?.find((prompt) => prompt?.moduleProjectId === projectId)

    if (moduleInfo) {
        return moduleInfo?.additionalRequiredTags
    }
    return []
}
export const getPromptModuleFullUrl = (moduleProjectId: string): string | null => {
    const promptRoute = PROMT_MODULE_ROUTES[moduleProjectId];
    if (!promptRoute) return null;
    return `${process.env.REACT_APP_URL_MEDIIIA_COM}/ai${promptRoute}`;
}
